export const normalizeSearchText = (value = '') =>
  String(value)
    .trim()
    .toLocaleLowerCase('uk-UA')
    .replace(/\s+/g, ' ');

const toValues = (value) => (
  Array.isArray(value) ? value : value == null ? [] : [value]
);

export const getSearchTerms = (value) =>
  normalizeSearchText(value)
    .replace(/^#+/, '')
    .split(/[\s-]+/)
    .map((term) => term.replace(/^#+/, ''))
    .filter(Boolean);

export const buildNewsSearchHaystack = (news = {}) => [
  news.title,
  news.author,
  news.category,
  ...toValues(news.sections),
  ...toValues(news.tags),
].map(normalizeSearchText).filter(Boolean).join(' ');

export const matchesNewsSearch = (news, queryText) => {
  const terms = getSearchTerms(queryText);
  if (terms.length === 0) return false;

  const haystack = buildNewsSearchHaystack(news);
  return terms.every((term) => haystack.includes(term));
};

export const buildNewsSearchFields = (news = {}) => {
  const searchTitle = normalizeSearchText(news.title);
  const searchAuthor = normalizeSearchText(news.author);
  const searchCategory = normalizeSearchText(news.category);
  const searchTags = toValues(news.tags)
    .map(normalizeSearchText)
    .filter(Boolean);
  const searchSections = toValues(news.sections)
    .map(normalizeSearchText)
    .filter(Boolean);
  const searchText = [
    searchTitle,
    searchAuthor,
    searchCategory,
    ...searchSections,
    ...searchTags,
  ].filter(Boolean).join(' ');
  const searchTokens = [...new Set(
    getSearchTerms(searchText)
  )];

  return {
    searchTitle,
    searchAuthor,
    searchCategory,
    searchTags,
    searchSections,
    searchText,
    searchTokens,
  };
};

export const buildLegacyTagCandidates = (value) => {
  const normalized = normalizeSearchText(value).replace(/^#+/, '');
  if (!normalized) return [];

  const words = normalized.split(' ').filter(Boolean);
  const titleCase = (items) => items
    .map((word) => word.charAt(0).toLocaleUpperCase('uk-UA') + word.slice(1))
    .join(' ');
  const orders = words.length === 2
    ? [words, [words[1], words[0]]]
    : [words];

  return [...new Set(orders.flatMap((order) => {
    const phrase = order.join(' ');
    return [
      phrase,
      titleCase(order),
      phrase.toLocaleUpperCase('uk-UA'),
    ];
  }))].slice(0, 10);
};

